import { render } from "./AdminObjects.vue?vue&type=template&id=44d0fcb0&scoped=true"
import script from "./AdminObjects.vue?vue&type=script&lang=js"
export * from "./AdminObjects.vue?vue&type=script&lang=js"

import "./AdminObjects.vue?vue&type=style&index=0&id=44d0fcb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d0fcb0"]])

export default __exports__